import React, { useState, useEffect } from 'react';
import { TextField, IconButton } from '@material-ui/core';
import { Visibility as ViewIcon } from '@material-ui/icons';
import Table, {
  columnType,
  tempFilteredRows,
} from '../../components/ClearingTable/Table';
import { listProfitAndLoss } from '../../services/ProfitAndLossService';
import {
  notifyInfo,
  notifyError,
  notifyWarning,
} from '../../components/Messages/Notification';
import Button from '../../components/Buttons/Button';
import AutoCompleteCorrespondent from '../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountNo from '../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteMasterAccountNo from '../../components/AutoComplete/AutoCompleteMasterAccountNo';
import SelectSystemCode from '../../components/Dropdown/SelectSystemCode';
import AutoCompleteSymbol from '../../components/AutoComplete/AutoCompleteSymbol';
import AutoCompleteBranch from '../../components/AutoComplete/AutoCompleteBranch';
import AutoCompleteRep from '../../components/AutoComplete/AutoCompleteRep';
import ProfitAndLossTableDetailsTable from './Components/ProfitAndLossTableDetailsTable';
import { formatCurrencySymbol } from '../../lib/fmt2';
import { getPreviousDate } from '../../services/ProfileService';
import QueryParam from '../../services/QueryParamService';
import Text from '../../components/Typography/Text';

export default function ProfitAndLoss() {
  //Set value of system date search parameter
  useEffect(
    () => {
      async function init() {
        if (searchData.fromDate) return;

        const systemDate = await getPreviousDate();
        setSearchData({
          ...searchData,
          fromDate: systemDate,
          toDate: systemDate,
        });
        setPaginationData({
          ...paginationData,
          fromDate: systemDate,
          toDate: systemDate,
        });
      }

      if (searchData.search) {
        handleSearch();
      }

      init();
    },
    // eslint-disable-next-line
    []
  );
  const [lockTable, setLockTable] = useState(true);
  const [previousRows, setPreviousRows] = useState(0);
  const [pagination, setPagination] = useState({});
  const [rowData, setRowData] = React.useState({});
  const [footerData, setFooterData] = useState({});
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  //search parameters initial value
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      fromDate: '',
      toDate: '',
      plType: '',
      correspondent: '',
      branch: '',
      accountNo: '',
      masterAccountNo: '',
      rep: '',
      assetType: '',
      symbol: '',
      search: false,
    })
  );
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [paginationData, setPaginationData] = React.useState(
    QueryParam.get({
      fromDate: '',
      toDate: '',
      plType: '',
      correspondent: '',
      branch: '',
      accountNo: '',
      masterAccountNo: '',
      rep: '',
      assetType: '',
      symbol: '',
    })
  );

  const columns = [
    {
      name: '',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div align={'left'} className="grd-row" style={{ margin: 0, padding: 0 }}>
              <div align={'left'} className="grd-cell">
                <IconButton
                  aria-label="view"
                  onClick={() => {
                    handleOpen(tempFilteredRows[dataIndex]);
                  }}
                >
                  <ViewIcon />
                </IconButton>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'processDate',
      label: 'Process Date',
      type: columnType.date,
    },
    {
      name: 'systemDate',
      label: 'System Date',
      type: columnType.date,
    },
    {
      name: 'accountId',
      label: 'Account ID',
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'rep',
      label: 'Rep',
    },
    {
      name: 'originalCusip',
      label: 'Original Cusip',
    },
    {
      name: 'assetType',
      label: 'Asset Type',
    },
    {
      name: 'symbol',
      label: 'Symbol',
    },
    {
      name: 'plType',
      label: 'PL Type',
    },
    {
      name: 'symbolDescription',
      label: 'Symbol Description',
    },
    {
      name: 'realized',
      label: 'Realized',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'marketValue',
      label: 'Market Value',
      type: columnType.amount,
      addFooter: true,
    },
    {
      name: 'ytdRealized',
      label: 'YTD Realized',
      type: columnType.amount,
      // addFooter: true,
    },
    {
      name: 'subAccountNo',
      label: 'Sub Account No',
    },
    {
      name: 'shortTermGain',
      label: 'Short Term Gain',
      type: columnType.amount,
    },
    {
      name: 'shortTermLoss',
      label: 'Short Term Loss',
      type: columnType.amount,
    },
    {
      name: 'shortTermNet',
      label: 'Short Term Net',
      type: columnType.amount,
    },
    {
      name: 'longTermGain',
      label: 'Long Term Gain',
      type: columnType.amount,
    },
    {
      name: 'longTermLoss',
      label: 'Long Term Loss',
      type: columnType.amount,
    },
    {
      name: 'longTermNet',
      label: 'Long Term Net',
      type: columnType.amount,
    },
    {
      name: 'ytdShortTermGain',
      label: 'YTD Short Term Gain',
      type: columnType.amount,
    },
    {
      name: 'ytdShortTermLoss',
      label: 'YTD Short Term Loss',
      type: columnType.amount,
    },
    {
      name: 'ytdShortTermNet',
      label: 'YTD Short Term Net',
      type: columnType.amount,
    },
    {
      name: 'ytdLongTermGain',
      label: 'YTD Long Term Gain',
      type: columnType.amount,
    },
    {
      name: 'ytdLongTermLoss',
      label: 'YTD Long Term Loss',
      type: columnType.amount,
    },
    {
      name: 'ytdLongTermNet',
      label: 'YTD Long Term Net',
      type: columnType.amount,
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    serverSide: true,
  };

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };

    const data = await listProfitAndLoss(searchDataCsv, paginationCopy);
    return data.profitandlossList;
  };

  const handleSearch = async (paginationChange) => {
    let valid = true;

    if (!searchData.fromDate) {
      notifyWarning('From Date is required.');
      valid = false;
    }

    if (!searchData.toDate) {
      notifyWarning('To Date is required.');
      valid = false;
    }

    if (!valid) {
      return;
    }

    try {
      setLoading(true);
      if (paginationChange !== true) {
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }
      QueryParam.set(searchData);

      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };
      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }

      const data = await listProfitAndLoss(searchData, paginationCopy);
      setSearchDataCsv(searchData);
      setTotalRows(data.summary.totalRows);
      setPreviousRows(totalRows);
      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(data.profitandlossList);
      if (paginationChange !== true) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }
      setFooterData({
        realized: formatCurrencySymbol(data.summary.realized),
        marketValue: formatCurrencySymbol(data.summary.marketValue),
      });
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({
      ...searchData,
      [input.name]: input.value,
    });
  };

  //Opens modal for edit
  const handleOpen = (data) => {
    setRowData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Profit and Loss" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <TextField
              name="fromDate"
              fullWidth
              label="From Date"
              type="date"
              value={searchData.fromDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required={true}
              inputProps={{ max: searchData.toDate }}
            />
          </div>
          <div className="grd-cell">
            <TextField
              name="toDate"
              fullWidth
              label="To Date"
              type="date"
              value={searchData.toDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required={true}
              inputProps={{ min: searchData.fromDate }}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteCorrespondent
              fullWidth
              name="correspondent"
              value={searchData.correspondent}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountNo
              freeSolo={true}
              name="accountNo"
              label="Account No"
              value={searchData.accountNo}
              correspondent={searchData.correspondent}
              onChange={handleChange}
              type="client"
            ></AutoCompleteAccountNo>
          </div>
          <div className="grd-cell">
            <AutoCompleteMasterAccountNo
              freeSolo={true}
              name="masterAccountNo"
              label="Master Account No"
              value={searchData.masterAccountNo}
              onChange={handleChange}
              type="client"
            ></AutoCompleteMasterAccountNo>
          </div>
          <div className="grd-cell">
            <AutoCompleteBranch
              required={false}
              freeSolo={true}
              name="branch"
              label="Branch"
              value={searchData.branch}
              onChange={handleChange}
              type="text"
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            ></AutoCompleteBranch>
          </div>
          <div className="grd-cell">
            <AutoCompleteRep
              required={false}
              freeSolo={true}
              name="rep"
              label="Rep"
              value={searchData.rep}
              onChange={handleChange}
              onKeyDown={(e) => (e.keyCode === 13 ? handleSearch() : null)}
            ></AutoCompleteRep>
          </div>
          <div className="grd-cell">
            <AutoCompleteSymbol
              fullWidth
              name="symbol"
              value={searchData.symbol}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="plType"
              label="PL Type"
              type="Type"
              subType="PL Type"
              value={searchData.plType}
              onChange={handleChange}
            ></SelectSystemCode>
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Profit and Loss'}
          data={rows}
          columns={columns}
          options={options}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
          footerData={footerData}
          getCsvData={getCsvData}
        />
      </div>
      {open && (
        <ProfitAndLossTableDetailsTable
          onClose={handleClose}
          open={open}
          value={rowData}
        ></ProfitAndLossTableDetailsTable>
      )}
    </form>
  );
}
